import { render, staticRenderFns } from "./Lokas.vue?vue&type=template&id=cd6a6c3e"
import script from "./Lokas.vue?vue&type=script&lang=js"
export * from "./Lokas.vue?vue&type=script&lang=js"
import style0 from "./Lokas.vue?vue&type=style&index=0&id=cd6a6c3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports